import type { ReactNode } from 'react'
import type { ModoVisualizacao } from '../../visualizacao3d/componentes/contextoMaquete'
import {
  IconeAnatomia,
  IconeCamadas,
  IconeCena,
  IconeConstrucao,
  IconeLegenda,
} from '../icones'
import { PRESETS, MODOS_MAQUETE } from '../presetsModo'
import type { FerramentasModulo } from './tipos'

export interface PropsEstrutura {
  painelAnatomia: () => ReactNode
  painelDetalhes: () => ReactNode
  painelCamadas: () => ReactNode
  painelCena: () => ReactNode
  legenda: () => ReactNode
  nomeVeiculo: string
  etapaAnatomia: string
  /** Quantidade de dispositivos SRS que o perfil declara. */
  quantidadeSrs: number
  selecao: {
    id: string
    nome: string
    classificacao?: string
    estado?: string
    acoes: ReactNode
  } | null
  aoLimparSelecao: () => void
  modo: ModoVisualizacao
  aoAplicarModo: (modo: ModoVisualizacao) => void
  explodido: boolean
  aoMudarExplodido: (explodido: boolean) => void
}

/**
 * Estrutura veicular: anatomia, construção, camadas, cena e legenda.
 *
 * O alternador Explodido e os presets de visualização
 * ficam em ações rápidas para troca imediata durante a aula expositiva.
 */
export function ferramentasEstrutura(p: PropsEstrutura): FerramentasModulo {
  return {
    grupos: [
      { id: 'anatomia', rotulo: 'Anatomia', icone: <IconeAnatomia />, conteudo: p.painelAnatomia },
      {
        id: 'construcao',
        rotulo: 'Construção',
        icone: <IconeConstrucao />,
        badge: p.selecao ? '1' : undefined,
        conteudo: p.painelDetalhes,
      },
      { id: 'camadas', rotulo: 'Camadas', icone: <IconeCamadas />, conteudo: p.painelCamadas },
      { id: 'cena', rotulo: 'Cena', icone: <IconeCena />, conteudo: p.painelCena },
      { id: 'legenda', rotulo: 'Legenda', icone: <IconeLegenda />, conteudo: p.legenda },
    ],
    chips: [],
    acoesRapidas: (
      <div className="grupo-acoes-rapidas-estrutura" style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
        {/* Um só alternador: "Montado" era apenas o estado desligado dele, e o
            par de botões gastava uma linha inteira do canvas no celular. */}
        <button
          type="button"
          className={`btn-acao-cad ${p.explodido ? 'btn-acao-cad--primario' : 'btn-acao-cad--secundario'}`}
          onClick={() => p.aoMudarExplodido(!p.explodido)}
          aria-pressed={p.explodido}
        >
          Explodido
        </button>
        <div className="ribbon-pilulas-cad" role="group" aria-label="Modos de visualização">
          {MODOS_MAQUETE.map((item) => (
            <button
              key={item}
              type="button"
              className={`btn-acao-cad ${p.modo === item ? 'btn-acao-cad--primario' : 'btn-acao-cad--secundario'}`}
              onClick={() => p.aoAplicarModo(item)}
              aria-pressed={p.modo === item}
            >
              {PRESETS[item].rotulo}
            </button>
          ))}
        </div>
      </div>
    ),
    inspetor: p.selecao && {
      titulo: p.selecao.nome,
      subtitulo: p.selecao.classificacao ?? 'Peça da estrutura',
      propriedades: [
        ...(p.selecao.estado ? [{ rotulo: 'Estado', valor: p.selecao.estado }] : []),
        { rotulo: 'Modo de visualização', valor: PRESETS[p.modo].rotulo },
        {
          rotulo: 'Dispositivos SRS no perfil',
          valor: `${p.quantidadeSrs} — declarados pelo perfil didático, não afirmação sobre veículos reais`,
        },
      ],
      acoes: p.selecao.acoes,
      aoFechar: p.aoLimparSelecao,
    },
  }
}
